import { useLocation } from 'react-router-dom';
import SidebarMenuItem from './SidebarMenuItem';
import { governanceSidebarItems } from './GovernanceSidebarData';
import { departmentSidebarItems } from '../../Pages/Department/DepartmentSidebarData';

const SidebarMenu = () => {
  const location = useLocation();

  const sidebarItems = location.pathname.startsWith('/department') ? departmentSidebarItems : governanceSidebarItems;

  const normalItems = sidebarItems.filter((item) => item.label !== 'Ai Chatbot');

  const aiItem = sidebarItems.find((item) => item.label === 'Ai Chatbot');

  return (
    <>
      <div className="space-y-2">
        {normalItems.map((item) => (
          <SidebarMenuItem key={item.id} {...item} />
        ))}
      </div>

      {aiItem && (
        <>
          <div className="border-t border-white/10 my-6" />
          <SidebarMenuItem {...aiItem} />
        </>
      )}
    </>
  );
};

export default SidebarMenu;
